import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { checkIsClientSide } from "../../../../utils/ym";
export var getIsSmsStatusReceived = function getIsSmsStatusReceived(status) {
  return status.toLowerCase().includes('sms');
};
export var getUrl = function getUrl(params) {
  var _window$location$href, _window$location;
  if (!checkIsClientSide()) return '';
  var urlObject = new URL((_window$location$href = (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.href) !== null && _window$location$href !== void 0 ? _window$location$href : '');
  params.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    urlObject.searchParams.append(key, value);
  });
  return urlObject.toString();
};